<div class="page-err">
  <div class="err-container text-center">
    <div class="err">
      <h1>401</h1>
      <h2>Sorry, we could not authenticate you against our servers</h2>
    </div>

    <div class="err-body">
      <a mat-raised-button href="/" class="btn-lg">Try Again</a>
    </div>
  </div>
</div>
